import type { FC } from 'react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Controller, useFormContext } from 'react-hook-form';
import { DiscountFormField } from '../../../types';
import AppliesToDropdown from './AppliesToDropdown';

interface Props {
  inputClassName?: string;
}

const AppliesToSelector: FC<Props> = ({ inputClassName }) => {
  const { t } = useTranslation();
  const { control, errors } = useFormContext();

  const items = useMemo(
    () => [
      {
        label: t('studio.discountModal.form.appliesToProductInput.option.any_shop_product'),
        subLabel: t(
          'studio.discountModal.form.appliesToProductInput.option.any_shop_product.subLabel'
        ),
        value: 'any_shop_product',
      },
      {
        label: t('studio.discountModal.form.appliesToProductInput.option.any_exclusive'),
        value: 'any_exclusive',
      },
      {
        label: t('studio.discountModal.form.appliesToProductInput.option.any_pcp'),
        value: 'any_pcp',
      },
      {
        label: t('studio.discountModal.form.appliesToProductInput.option.any_pg'),
        value: 'any_pg',
      },
      {
        label: t('studio.discountModal.form.appliesToCategoryInput.option.subscriptions'),
        value: 'any_tier',
      },
    ],
    [t]
  );

  return (
    <Controller
      name={DiscountFormField.AppliesToProduct}
      control={control}
      render={({ onChange, value, name }) => {
        const error = errors[name];
        return (
          <AppliesToDropdown
            id={DiscountFormField.AppliesToProduct}
            className={inputClassName}
            label={t('studio.discountModal.form.appliesToCategoryInput.label')}
            value={value}
            onChange={onChange}
            error={error?.message}
            isRequired
            items={items}
          />
        );
      }}
    />
  );
};
AppliesToSelector.displayName = 'AppliesToSelector';

export default AppliesToSelector;
